import { useEffect } from "react";

/**
 * Locks body scroll (e.g. when a fullscreen overlay or modal is open).
 * Call with no args to lock on mount and unlock on unmount.
 * Call with a boolean to lock when true and unlock when false.
 */
export function useLockBodyScroll(shouldLock = true): void {
  useEffect(() => {
    if (!shouldLock) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [shouldLock]);
}
